module.exports = __webpack_public_path__ + "3235f487.svg";